import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import FileUploadBlockchain from './../projects_t_engineering/FileUpload/FileUploadBlockchain';
import DocumentModelTopics from "../projects_t_engineering/FileUpload/documentModel/DocumentModelTopics";
import { stylesPgMenuInf } from '../styles';

const ProjectTabLegal = ({ user, project }) => {
  const documentModels = useSelector((state) => state.documentModels.models);

  // Busca o modelo de documento pelo nome
  const modeloJur = documentModels.find(model => model.nome === 'Modelo Jurídico');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // Evita erro caso o modelo ainda não tenha sido carregado
  if (!modeloJur) {
    return <div>Carregando modelo Jurídico...</div>;
  }

  return (
    <div >

      <DocumentModelTopics
        projectId={project.id}
        modeloId={modeloJur.id}
        telaName="Jurídico"
      />
    </div>
  );
};

export default ProjectTabLegal;
